import Scheme from 'async-validator'
export default function (descriptor) {
  return new Scheme(descriptor)
}



// WEBPACK FOOTER //
// ./src/util/validator.js